/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/question-mark-2194193': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M15.333 9.5A3.5 3.5 0 008.8 7.75a1 1 0 001.733 1A1.503 1.503 0 0111.833 8a1.5 1.5 0 110 3h-.003a.95.95 0 00-.19.039 1.032 1.032 0 00-.198.04.983.983 0 00-.155.105 1.008 1.008 0 00-.162.11 1.005 1.005 0 00-.117.174.978.978 0 00-.097.144 1.023 1.023 0 00-.043.212.948.948 0 00-.035.176v1l.002.011v.491a1 1 0 001 .998h.003a1 1 0 00.998-1.002l-.002-.662A3.494 3.494 0 0015.333 9.5zm-4.203 6.79a1 1 0 00.7 1.71 1.036 1.036 0 00.71-.29 1.015 1.015 0 000-1.42 1.034 1.034 0 00-1.41 0z"/>'
  }
})
